import React, { useState, useEffect, Fragment, useMemo, useRef } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactTable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { JIRA_LINK } from "../../utils/constants";
import Pagination from "react-js-pagination";
import { toast } from "react-toastify";
import Select from "../partials/Select";
import Datepicker from "../partials/Datepicker";
import { dateFormat } from "../../utils/dateFormat";
import {priorities} from "../../utils/constants";
import { tasksStatuses } from "../../utils/constants";


const Tasks = ({ auth }) => {
	const [date, setDate] = useState();
	const [records, setRecords] = useState([]);
	const [users, setUsers] = useState([])
	const [projects, setProjects] = useState([])
	const [selectedProjects, setSelectedProjects] = useState([])
	const [selectedUsers, setSelectedUsers] = useState([])
	const [selectedPriorities, setSelectedPriorities] = useState([])
	const [selectedStatus, setSelectedStatus] = useState([])
	const [search, setSearch] = useState("")
	const [activePage, setActivePage] = useState(1)
	const [pageSize, setPageSize] = useState(20)
	const [total, setTotal] = useState(0)
	const [showDatepicker, setShowDatepicker] = useState(false)
	const showDatepickerRef = useRef()
	const [showAllUsers, setShowAllUsers] = useState(false);

	const columns = useMemo(() => [
		{
			key: "type",
			text: "Ticket",
			className: "type",
			align: "left",
			sortable: true,
			cell: record => (
				<a
					href={`${JIRA_LINK}/browse/${record?.type}`}
					target="_blank"
				>
					{record?.type}
				</a>
			),
		},
		{
			key: "message",
			text: "Description",
			className: "message",
			align: "left",
			sortable: true,
		},
		{
			key: "priority",
			text: "Priority",
			className: "priority",
			align: "left",
			sortable: true,
		},
		{
			key: "ticket_status",
			text: "Status",
			className: "ticket_status",
			align: "left",
			sortable: true,
		},
		{
			key: "user_id",
			text: "Email",
			className: "user_id",
			align: "left",
			sortable: true,
			cell: record => (
				<span>{record?.user_id?.email}</span>
			),
		},
		{
			key: "createdAt",
			text: "createdAt",
			className: "createdAt",
			align: "left",
			sortable: true,
			cell: record => (
				<span>{new Date(record?.createdAt).toDateString()}</span>
			),
		},
		{
			key: "updatedAt",
			text: "updatedAt",
			className: "updatedAt",
			align: "left",
			sortable: true,
			cell: record => (
				<span>{new Date(record?.updatedAt).toDateString()}</span>
			),
		}
	], [auth?.user]);

	const config = {
		page_size: pageSize,
		length_menu: [20, 30, 50],
		filename: "Tasks",
		no_data_text: 'No task found!',
		button: {
			excel: true,
			print: true,
			csv: true,
		},
		language: {
			length_menu: "Show _MENU_ result per page",
		},
		show_length_menu: true,
		show_filter: true,
		show_pagination: false,
		show_info: false,
	};

	const getData = () => {
		const query = { page: activePage, perPage: pageSize, search };
		const body = {
			users_id: selectedUsers?.map(itm => itm.value) || [],
			priority: selectedPriorities?.map(itm => itm.value) || [],
			ticket_status: selectedStatus?.map(itm => itm.value) || [],
			projects: selectedProjects?.map(itm => itm.value) || [],
			date: date ? date[0] : null,
			projectDoNotCompleteOnly: true,
		};
		axios
			.post(`/api/tasks?${new URLSearchParams(query).toString()}`, body)
			.then(res => {
				setRecords(res.data?.tasks || []);
				setTotal(res.data?.total || 0);
			})
			.catch(error => {
				console.error("Error fetching data:", error.message);
			});
	};

	const getUsers = () => {
		axios
			.get(`/api/user-data`)
			.then(res => {
				const formattedUsers = res.data?.map(user => ({
					...user,
					value: user._id,
					label: user.email,
				})) || [];
				setUsers(formattedUsers);
			})
			.catch(error => {
				console.error("Error fetching data:", error.message);
			});
	};


	const getProjects = () => {
		axios
			.get(`/api/getprojects`)
			.then(res => {
				setProjects(res.data?.projects?.map(itm => ({ value: itm?._id, label: itm?.name })) || []);
			})
			.catch(error => {
				console.error("Error fetching data:", error.message);
			});
	};

	const onChange = pageData => {
		setSearch(pageData?.filter_value)
		setPageSize(parseInt(pageData?.page_size))
	};

	const sendMessage = async (text) => {
		try {
			const res = await axios.post(
				"/api/notify-slack",
				{
					text,
					username: auth?.user?.name,
				}
			);

			if (res.data?.ok) {
				toast.success("Notification sent")
			}
		} catch (error) {
			console.log(error);
		}
	}

	const handleClickOutside = (event) => {
		if (showDatepickerRef.current && !showDatepickerRef.current.contains(event.target)) {
			setShowDatepicker(false);
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		getUsers();
		getProjects()
	}, []);

	useEffect(() => {
		getData();
	}, [search, selectedUsers, date, selectedProjects, selectedStatus, selectedPriorities, pageSize, activePage]);

	return (
		<div>
			<Navbar />
			<div className="d-flex" id="wrapper">
				<Sidebar />

				<div id="page-content-wrapper">
					<div className="container-fluid backdrop-cont mt-2 pl-2">
						<div className="d-flex align-items-center">
							<button
								className="btn btn-link"
								id="menu-toggle"
								onClick={() => {
									document.body.classList.toggle("sidebar-expanded");
								}}
							>
								<FontAwesomeIcon icon={faList} />
							</button>
							<h5 className="text-primary mb-0">Tasks List</h5>
						</div>
						<div className="d-flex align-items-center mb-3" >
							<div className="px-2 pr-2 w-100">
								<div className="row g-2">
									{auth?.user?.role === 1 && (
										<div className="col-12 col-md-6 col-lg-3 mt-2 position-relative" style={{ zIndex: 111111111 }}>
											<div className="filter-item position-relative">
												<div
													className="position-absolute d-flex  align-items-center"
													style={{ top: "-25px", right: "0", zIndex: 2 }}
												>
													<input
														type="checkbox"
														id="showAllUsers"
														style={{ width: "15px", height: "15px" }}
														className="form-check-input me-1"
														checked={showAllUsers}
														onChange={(e) => setShowAllUsers(e.target.checked)}
													/>
													<label
														className="form-check-label "
														htmlFor="showAllUsers"
														style={{ fontSize: "14px", fontWeight: "500" }}
													>
														Select All
													</label>
												</div>
												<Select
													allOptions={showAllUsers ? users : users.filter((u) => u.status === 1)}
													selectedOptions={selectedUsers}
													setSelectedOptions={setSelectedUsers}
													placeholder="Select Users"
												/>
											</div>
										</div>
									)}


									<div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 11111111 }}>
										<div className="filter-item">
											<Select
												allOptions={priorities}
												selectedOptions={selectedPriorities}
												setSelectedOptions={setSelectedPriorities}
												placeholder="Select Priority"
											/>
										</div>
									</div>
									<div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 111111 }}>
										<div className="filter-item">
											<Select
												allOptions={tasksStatuses}
												selectedOptions={selectedStatus}
												setSelectedOptions={setSelectedStatus}
												placeholder="Select Status"
											/>
										</div>
									</div>
									<div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 11111 }}>
										<div className="filter-item">
											<Select
												allOptions={projects}
												selectedOptions={selectedProjects}
												setSelectedOptions={setSelectedProjects}
												placeholder="Select Project"
											/>
										</div>
									</div>
								</div>
								<div className="row g-2 mt-2">
									<div className="select_wrapper date_wrapper col-12 col-md-6 col-lg-3 mt-2">
										<div className="filter-item">
											<div
												onClick={() => setShowDatepicker(true)}
												className="selected_date"
											>
												{date ? <>
													{dateFormat(date?.[0]?.startDate)} - {dateFormat(date?.[0]?.endDate)}
												</> : "Select Date"}

												<div ref={showDatepickerRef}>
													{showDatepicker && <Datepicker
														date={date || [
															{
																startDate: new Date(),
																endDate: new Date(),
																key: 'selection'
															}
														]}
														setDate={setDate}
													/>}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<br />
						<div className="task-table">
							<ReactTable
								config={config}
								records={records}
								columns={
									auth?.user?.role === 1 ?
										[
											...columns,
											{
												key: "action",
												text: "Action",
												className: "action",
												width: 100,
												align: "left",
												sortable: false,
												cell: record => (
													<Fragment>
														<button
															onClick={() => sendMessage(`${record?.type} ${record?.message}`)}
															className="btn btn-primary btn-sm"
															style={{ marginRight: '5px' }}>
															<i className="fa fa-slack"></i>
														</button>
													</Fragment>
												),
											}
										] : columns
								}
								onChange={onChange}
							/>
						</div>
						<div className="d-flex justify-content-center my-2">
							<Pagination
								activePage={activePage}
								itemsCountPerPage={pageSize}
								totalItemsCount={total}
								pageRangeDisplayed={5}
								onChange={e => setActivePage(e)}
								nextPageText="Next"
								prevPageText="Prev"
								firstPageText="First"
								lastPageText="Last"
								itemClass="cursor-pointer position-relative inline-flex items-center px-3 py-2
								text-sm font-medium text-gray-500 border"
								activeClass="border-active"
								activeLinkClass="font-bold"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

Tasks.propTypes = {
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
	auth: state.auth,
	records: state.records,
});

export default connect(mapStateToProps)(Tasks);